export default {
      id: "triangle-down-usage",
      viewBox: "0 0 10 8",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#triangle-down",
      toString: function () {
        return this.url;
      }
    }